import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import dayjs from 'dayjs';
import 'dayjs/locale/en-gb';
import 'dayjs/locale/en';
import 'dayjs/locale/fi';
import 'dayjs/locale/nb';
import 'dayjs/locale/pl';
import 'dayjs/locale/sv';
import quarterOfYear from 'dayjs/plugin/quarterOfYear';

import { Page } from '../../ui';

import { useSales, useInvitations } from '../statistics/hooks/useStatisticsState';
import { fetchStore } from '../webshop/globalSlice';
import CourseUsageAnalytics from './components/CourseUsageAnalytics';
import TimePeriodSelector from './components/TimePeriodSelector';
import StatisticsCards from './components/StatisticsCards';
import SalesDataTable from './components/SalesDataTable';
import { useRefetchOnAuthChange, useUser } from '../auth/hooks';
import PageSection from '../../ui/Page/PageSection';

dayjs.extend(quarterOfYear);

const Insights = () => {
  const dispatch = useDispatch();
  const user = useUser();
  const storeName = user?.username;

  const [startDate, setStartDate] = useState(dayjs().startOf('quarter'));
  const [endDate, setEndDate] = useState(dayjs());
  const [courseModalisOpen, setCourseModalisOpen] = useState();

  const dates = {
    startDate: startDate.toISOString().split('T')[0],
    endDate: endDate.toISOString().split('T')[0],
  };

  const { sales, refetch: refetchSales } = useSales(dates);
  const { invitations, refetch: refetchInvitations } = useInvitations(dates);

  // Refetch insights when auth identity changes
  useRefetchOnAuthChange(() => {
    refetchSales();
    refetchInvitations();
  });

  useEffect(() => {
    storeName && dispatch(fetchStore({ store: storeName }));
  }, [dispatch, storeName]);

  const openAnalyticDetails = (course) => {
    setCourseModalisOpen(course);
  };

  return (
    <Page gap='60' staticElements={<TimePeriodSelector startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />}>
      <PageSection>
        <StatisticsCards sales={sales} invitations={invitations} />
      </PageSection>
      <PageSection>
        <SalesDataTable sales={sales} invitations={invitations} openAnalyticDetails={openAnalyticDetails} dates={dates} />
      </PageSection>
      <CourseUsageAnalytics
        startDate={startDate.toISOString().split('T')[0]}
        endDate={endDate.toISOString().split('T')[0]}
        courseToShow={courseModalisOpen}
        onClose={() => setCourseModalisOpen()}
      />
    </Page>
  );
};

export default Insights;
